import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'react-avatar';
import {
  Button,
  ButtonToolbar,
  ButtonGroup,
} from 'react-bootstrap';
import { Link } from 'react-router';

class brandDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.imageClick = this.imageClick.bind(this);
  }
  imageClick(brandInfo,contactData){
    this.setState({showModal:true});
    this.props.BrandPopUp(brandInfo,contactData);
  }
  
  render() {
    const brandInfo = this.props.brand;
    const contactData = [];
    if(this.props.contacts){
      this.props.contacts.forEach((c) => {
        if(brandInfo.id == c.brand){
          contactData.push(c)
        }
      });
    }
    
    const style = {
      textAlign: "center",
      color: "white"
    }
    const nameStyle = {
      marginTop: "5px"
    }
    return (
            <div className="col-sm-4 col-md-4">           
              <Link>
                <div style={style}>
                  <img src={brandInfo.logo} width="200" height="90" onClick={() => this.imageClick(brandInfo,contactData)}/>
                </div>
              </Link><br/>
            </div>
      );
  }
}

export default brandDetails;


// WEBPACK FOOTER //
// src/routes/home/components/BrandDetails.js